import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import Applications from "../components/Applications";

const Application = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <>
            {/* Navigation Bar */}
            <NavbarThree />

            {/* Breadcrumb */}
            <Breadcrumb title={"Applications"} />

            {/* Application */}
            <Applications />

            {/* Footer */}
            <FooterThree />
        </>
    );
};

export default Application;
